import { render, staticRenderFns } from "./ActivitySupplement.vue?vue&type=template&id=1bf64e9d&scoped=true&"
import script from "./ActivitySupplement.vue?vue&type=script&lang=js&"
export * from "./ActivitySupplement.vue?vue&type=script&lang=js&"
import style0 from "./ActivitySupplement.vue?vue&type=style&index=0&id=1bf64e9d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bf64e9d",
  null
  
)

export default component.exports